import React from 'react'
import moment from 'moment';

export const eligibilityOptions = [
  { value: '', label: '' },
  { value: 'Free', label: 'Free' },
  { value: 'Reduced', label: 'Reduced' },
  { value: 'Regular', label: 'Regular' }
];

export const statusOptions = [
  { value: '', label: '' },
  { value: 'Rejected', label: 'Rejected' },
  { value: 'Verified', label: 'Verified' },
  { value: 'No Response', label: 'No Response' }
];


export const testApplications = [
  {
    "createdBy": "marvin@gmail.com",
    "createdOn": 1616736383000,
    "applicationId": 1,
    "date": "03262021",
    "status": "pending",
    "prmyParentEmail": "marvin@gmail.com",
    "mealSchoolId": 701,
    "statusUpdateDate": null,
    "schoolYear": 2020,
    "studentRecIds": "3102,3108",
    "householdAppInfo": [
      {
        "fname": "Marvin",
        "lname": "Bragg",
        "mname": "",
        "filledTheApplication": true,
        "personType": "Adult",
        "assistancePrograms": [
          {
            "id": 1,
            "name": "Supplemental Nutrition Assistance Program (SNAP)",
            "accronym": "SNAP",
            "caseNumber": "",
            "isApplicable": false
          },
          {
            "id": 2,
            "name": "Temporary Assistance for Needy Families (TANF)",
            "accronym": "TANF",
            "caseNumber": "",
            "isApplicable": false
          },
          {
            "id": 3,
            "name": "Food Distribution Program on Indian Reservations (FDPIR)",
            "accronym": "FDPIR",
            "caseNumber": "",
            "isApplicable": false
          }
        ],
        "income": [
          {
            "source": "Earnings from Work",
            "amount": 500.0,
            "frequency": "52"
          }
        ],
        "contact": {
          "phone": "4805566336",
          "email": "vellanki.mca@gmail.com",
          "street1": "374 William S Canning Blvd",
          "street2": "",
          "city": "Phoenix",
          "state": "AZ",
          "zip": ""
        },
        "noIncome": false,
        "totalIncome": null,
        "ssn": "1234",
        "noSSN": false,
        "grade": "",
        "liveUnderFosterCare": false,
        "runaway": null,
        "ethenticity": null,
        "race": [

        ],
        "isFreeMeal": false,
        "studentRecId": 0
      },
      {
        "fname": "Cameron",
        "lname": "Dills",
        "mname": "",
        "filledTheApplication": false,
        "personType": "Student",
        "assistancePrograms": null,
        "income": [

        ],
        "contact": null,
        "noIncome": null,
        "totalIncome": null,
        "ssn": null,
        "noSSN": null,
        "grade": "one",
        "liveUnderFosterCare": true,
        "runaway": null,
        "ethenticity": "Hispanic or Latino",
        "race": [

        ],
        "isFreeMeal": true,
        "studentRecId": 3102
      },
      {
        "fname": "Cassidy",
        "lname": "Calderon",
        "mname": "",
        "filledTheApplication": false,
        "personType": "Student",
        "assistancePrograms": null,
        "income": [
          {
            "source": "Public Assistance/Child Support/Alimony",
            "amount": 200.0,
            "frequency": "52"
          }
        ],
        "contact": null,
        "noIncome": null,
        "totalIncome": null,
        "ssn": null,
        "noSSN": null,
        "grade": "two",
        "liveUnderFosterCare": false,
        "runaway": false,
        "ethenticity": "Hispanic or Latino",
        "race": [
          "American Indian or Alaskan Native"
        ],
        "isFreeMeal": false,
        "studentRecId": 3108
      }
    ],
    "declinedReasonList": [
      {
        "id": 1,
        "name": "Income over the allowable amount",
        "description": null,
        "isApplicable": false
      },
      {
        "id": 2,
        "name": "SNAP/TANF/FDPIR case # invalid",
        "description": null,
        "isApplicable": false
      },
      {
        "id": 3,
        "name": "Incomplete application.  The following is missing",
        "description": "",
        "isApplicable": false
      },
      {
        "id": 3,
        "name": "Other:",
        "description": "",
        "isApplicable": false
      }
    ]
  },
  {
    "createdBy": "robert1996@gmail.com",
    "createdOn": 1616736652000,
    "applicationId": 2,
    "date": "03262021",
    "status": "pending",
    "prmyParentEmail": "robert1996@gmail.com",
    "mealSchoolId": 701,
    "statusUpdateDate": null,
    "schoolYear": 2020,
    "studentRecIds": "3100",
    "householdAppInfo": [
      {
        "fname": "Robert",
        "lname": "Paul",
        "mname": "",
        "filledTheApplication": true,
        "personType": "Adult",
        "assistancePrograms": [
          {
            "id": 1,
            "name": "Supplemental Nutrition Assistance Program (SNAP)",
            "accronym": "SNAP",
            "caseNumber": "",
            "isApplicable": false
          },
          {
            "id": 2,
            "name": "Temporary Assistance for Needy Families (TANF)",
            "accronym": "TANF",
            "caseNumber": "34222234",
            "isApplicable": true
          },
          {
            "id": 3,
            "name": "Food Distribution Program on Indian Reservations (FDPIR)",
            "accronym": "FDPIR",
            "caseNumber": "",
            "isApplicable": false
          }
        ],
        "income": [

        ],
        "contact": {
          "phone": "4805566334",
          "email": "vellanki.mca@gmail.com",
          "street1": "2000 East Rio Salado Parkway",
          "street2": "",
          "city": "Tempe",
          "state": "AZ",
          "zip": "85281"
        },
        "noIncome": false,
        "totalIncome": null,
        "ssn": "",
        "noSSN": true,
        "grade": "",
        "liveUnderFosterCare": false,
        "runaway": null,
        "ethenticity": null,
        "race": [

        ],
        "isFreeMeal": false,
        "studentRecId": 0
      },
      {
        "fname": "Faith",
        "lname": "Bainbridge",
        "mname": "",
        "filledTheApplication": false,
        "personType": "Student",
        "assistancePrograms": null,
        "income": [

        ],
        "contact": null,
        "noIncome": null,
        "totalIncome": null,
        "ssn": null,
        "noSSN": null,
        "grade": "k",
        "liveUnderFosterCare": false,
        "runaway": null,
        "ethenticity": null,
        "race": [

        ],
        "isFreeMeal": true,
        "studentRecId": 3100
      }
    ],
    "declinedReasonList": [
      {
        "id": 1,
        "name": "Income over the allowable amount",
        "description": null,
        "isApplicable": false
      },
      {
        "id": 2,
        "name": "SNAP/TANF/FDPIR case # invalid",
        "description": null,
        "isApplicable": false
      },
      {
        "id": 3,
        "name": "Incomplete application.  The following is missing",
        "description": "",
        "isApplicable": false
      },
      {
        "id": 3,
        "name": "Other:",
        "description": "",
        "isApplicable": false
      }
    ]
  }
]

export const householdAppsColumns = [
  {
    accessor: 'applicationId',
    Header: 'Application Id',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'appliedDate',
    Header: 'Applied Date',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'schoolName',
    Header: 'School',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'studentName',
    Header: 'Student Name',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'currentEligibility',
    Header: 'Current Eligibility',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'applicationCategory',
    Header: 'Category',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'errorProne',
    Header: 'Errorprone',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'action',
    Header: 'Action',
    style: { textAlign: 'center' }
  }
]

export const householdAppsTestData = [
  {
    "applicationId": 3332432,
    "appliedDate": "08/02/2023",
    "schoolName": "School 1",
    "studentName": "Student 1",
    "currentEligibility": "Free",
    "category": "SNAP",
    "errorProne": 'Yes',
  },
  {
    "applicationId": 3332632,
    "appliedDate": "08/02/2023",
    "schoolName": "School 2",
    "studentName": "Student 2",
    "currentEligibility": "Free",
    "category": "FI",
    "errorProne": 'Yes',
  },
  {
    "applicationId": 3332732,
    "appliedDate": "08/02/2023",
    "schoolName": "School 3",
    "studentName": "Student 2",
    "currentEligibility": "Reduced",
    "category": "RI",
    "errorProne": 'Yes',
  },
  {
    "applicationId": 3332432,
    "appliedDate": "08/02/2023",
    "schoolName": "School 1",
    "studentName": "Student 1",
    "currentEligibility": "Free",
    "category": "SNAP",
    "errorProne": 'Yes',
  },
  {
    "applicationId": 3332632,
    "appliedDate": "08/02/2023",
    "schoolName": "School 1",
    "studentName": "Student 2",
    "currentEligibility": "Free",
    "category": "FI",
    "errorProne": '',
  },
  {
    "applicationId": 3332732,
    "appliedDate": "08/02/2023",
    "schoolName": "School 3",
    "studentName": "Student 2",
    "currentEligibility": "Reduced",
    "category": "RI",
    "errorProne": '',
  },
  {
    "applicationId": 3332832,
    "appliedDate": "08/02/2023",
    "schoolName": "School 1",
    "studentName": "Student 1",
    "currentEligibility": "Free",
    "category": "SNAP",
    "errorProne": '',
  },
  {
    "applicationId": 3332932,
    "appliedDate": "08/02/2023",
    "schoolName": "School 1",
    "studentName": "Student 1",
    "currentEligibility": "Free",
    "category": "FI",
    "errorProne": '',
  },
  {
    "applicationId": 3332232,
    "appliedDate": "08/02/2023",
    "schoolName": "School 1",
    "studentName": "Student 3",
    "currentEligibility": "Reduced",
    "category": "RI",
    "errorProne": '',
  },
]

export const addApplicationColumns = [
  {
    accessor: 'applicationId',
    Header: 'Application Id',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'appliedDate',
    Header: 'Applied Date',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'schoolName',
    Header: 'School',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'studentName',
    Header: 'Student Name',
    filterable: true,
    style: { textAlign: 'center' }
  },
  {
    accessor: 'currentEligibility',
    Header: 'Current Eligibility',
    filterable: true,
    style: { textAlign: 'center' }
  },
  {
    accessor: 'applicationCategory',
    Header: 'Category',
    filterable: true,
    style: { textAlign: 'center' }
  },
  {
    accessor: 'status',
    Header: 'Status',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'action',
    Header: 'Action',
    style: { textAlign: 'center' }
  }
]

export const sampleApplications = [
  {
    "applicationId": 3332432,
    "appliedDate": "08/02/2023",
    "schoolName": "School 1",
    "studentName": "Student 1",
    "currentEligibility": "Free",
    "category": "SNAP",
    "status": 'Approved',
  },
  {
    "applicationId": 3332632,
    "appliedDate": "08/02/2023",
    "schoolName": "School 2",
    "studentName": "Student 2",
    "currentEligibility": "Free",
    "category": "FI",
    "status": 'Approved',
  },
  {
    "applicationId": 3332732,
    "appliedDate": "08/02/2023",
    "schoolName": "School 3",
    "studentName": "Student 2",
    "currentEligibility": "Reduced",
    "category": "RI",
    "status": 'Approved',
  },
]

export const closeVerificationColumns = [
  {
    accessor: 'schoolName',
    Header: 'School Name',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'approvedApplications',
    Header: 'Approved Applications',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'selectedApplications',
    Header: 'Selected Applications',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'verifiedApplications',
    Header: 'Verified Applications',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'unverifiedApplications',
    Header: 'Unverified Applications',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'previousFreeStatusCount',
    Header: 'Previous Free Status Count',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'newFreeStatusCount',
    Header: 'New Free Status Count',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'previousReducedCount',
    Header: 'Previous Reduced Count',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'newReducedCount',
    Header: 'New Reduced Count',
    style: { textAlign: 'center' }
  },
]

export const closeVerificationData = [
  {
    "schoolName": "School 1",
    "approvedApplications": 100,
    "selectedApplications": 3,
    "verifiedApplications": 3,
    "unverifiedApplications": 0,
    "previousFreeStatusCount": 2,
    "newFreeStatusCount": 2,
    "previousReducedCount": 1,
    "newReducedCount": 1,
  },
  {
    "schoolName": "School 2",
    "approvedApplications": 200,
    "selectedApplications": 6,
    "verifiedApplications": 6,
    "unverifiedApplications": 0,
    "previousFreeStatusCount": 4,
    "newFreeStatusCount": 3,
    "previousReducedCount": 2,
    "newReducedCount": 3,
  },
  {
    "schoolName": "School 3",
    "approvedApplications": 200,
    "selectedApplications": 6,
    "verifiedApplications": 6,
    "unverifiedApplications": 0,
    "previousFreeStatusCount": 4,
    "newFreeStatusCount": 2,
    "previousReducedCount": 2,
    "newReducedCount": 4,
  },
  {
    "schoolName": "School 4",
    "approvedApplications": 400,
    "selectedApplications": 9,
    "verifiedApplications": 6,
    "unverifiedApplications": 3,
    "previousFreeStatusCount": 6,
    "newFreeStatusCount": 3,
    "previousReducedCount": 3,
    "newReducedCount": 3,
  },

]


export const reviewColumns = [
  {
    accessor: 'applicationId',
    Header: () => (
      <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
        Application <br /> ID
      </div>
    ),
    style: { textAlign: 'center' }
  },
  {
    accessor: 'appliedDate',
    Header: () => (
      <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
        Applied <br /> Date
      </div>
    ),
    style: { textAlign: 'center' }
  },
  // {
  //   accessor: 'applicationCategory',
  //   Header: () => (
  //     <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
  //       Application <br />Category
  //     </div>
  //   ),
  //   style: { textAlign: 'center' }
  // },
  {
    accessor: 'currentEligibility',
    Header: () => (
      <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
        Current <br /> Eligibility
      </div>
    ),
    style: { textAlign: 'center' }
  },
  {
    accessor: 'confirmOfficialSign',
    Header: 'Confirming Official Signature',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'directVerification',
    Header: 'Direct Verification',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'verificationLetterSent',
    Header: () => (
      <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
        Verification <br /> Letter <br /> Sent
      </div>
    ),
    style: { textAlign: 'center' }
  },
  // {
  //   accessor: 'isEligibilityConfirmed',
  //   Header: () => (
  //     <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
  //       Is Eligibility <br /> Confirmed?
  //     </div>
  //   ),
  //   Cell: row => (
  //     <div style={{ textAlign: 'center' }}>
  //       {row.value === 'yes' ? (
  //         <i className="fa fa-check" style={{ color: 'green' }} />
  //       ) : (
  //         <i className="fa fa-times" style={{ color: 'red' }} />
  //       )}
  //     </div>
  //   ),
  //   style: { textAlign: 'center' }
  // },
  // {
  //   accessor: 'isDVDone',
  //   Header: () => (
  //     <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
  //       Is DV <br /> Done?
  //     </div>
  //   ),
  //   Cell: row => (
  //     <div style={{ textAlign: 'center' }}>
  //       {row.value === 'yes' ? (
  //         <i className="fa fa-check" style={{ color: 'green' }} />
  //       ) : (
  //         <i className="fa fa-times" style={{ color: 'red' }} />
  //       )}
  //     </div>
  //   ),
  //   style: { textAlign: 'center' }
  // },
  {
    accessor: 'documentsReceived',
    Header: 'Documents Received',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'documentsVerified',
    Header: 'Documents Verified',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'status',
    Header: 'Status',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'documents',
    Header: () => (
      <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
        Documents <br /> Notes
      </div>
    ),
    style: { textAlign: 'center' }
  },

  {
    accessor: 'newEligibility',
    Header: 'New Eligibility',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'lastFollowUp',
    Header: () => (
      <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
        Last <br /> Follow <br /> Up
      </div>
    ),
    style: { textAlign: 'center' }
  },
  // {
  //   accessor: 'action',
  //   Header: 'Action',
  //   Cell: row => (
  //     <div style={{ textAlign: 'center' }}>
  //       <i className="fa fa-trash" style={{ color: 'black' }} />
  //     </div>
  //   ),
  //   style: { textAlign: 'center' }
  // }
]

export const reviewData = [
  {
    "applicationId": 3332432,
    "appliedDate": "08/07/2023",
    "applicationCategory": "ERRORPRONE",
    "status": "Verified",
    "currentEligibility": "Free",
    "isEligibilityConfirmed": "yes",
    "isDVDone": "yes",
    "documentsReceived": "yes",
    "documentsVerified": "yes",
    "newEligibility": "Free",
    "documents": "yes",
    "lastFollowUp": "10/06/2023",
  },
  {
    "applicationId": 3552432,
    "appliedDate": "08/07/2023",
    "applicationCategory": "ERRORPRONE",
    "status": "Verified",
    "currentEligibility": "Reduced",
    "isEligibilityConfirmed": "yes",
    "isDVDone": "yes",
    "documentsReceived": "yes",
    "documentsVerified": "no",
    "newStatus": "Free",
    "documents": "",
    "lastFollowUp": "10/06/2023",
  },
  {
    "applicationId": 3552462,
    "appliedDate": "08/08/2023",
    "applicationCategory": "ERRORPRONE",
    "status": "Verified",
    "currentEligibility": "Free",
    "isEligibilityConfirmed": "yes",
    "isDVDone": "yes",
    "documentsReceived": "yes",
    "documentsVerified": "yes",
    "newStatus": "reduced",
    "documents": "yes",
    "lastFollowUp": "10/06/2023",
  },
  {
    "applicationId": 4552462,
    "appliedDate": "08/18/2023",
    "applicationCategory": "ERRORPRONE",
    "status": "Verified",
    "currentEligibility": "Free",
    "isEligibilityConfirmed": "yes",
    "isDVDone": "yes",
    "documentsReceived": "no",
    "documentsVerified": "no",
    "newStatus": "free",
    "documents": "",
    "lastFollowUp": "",
  },

]

export const docsColumns = [
  {
    accessor: 'documentDesc',
    Header: 'Document',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'createdBy',
    Header: 'Added By',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'createdOn',
    Header: 'Added On',
    style: { textAlign: 'center' },
    width:100,
    Cell: ({ value }) => (
                    value && moment(value).isValid()
                        ? moment(value).format('YYYY-MM-DD') : '-'
           )
  },
]

export const docsData = [
  {
    "createdBy": "admin.pankaj@mealmanage.com",
    "createdOn": 1699869020000,
    "id": 8,
    "inputType": "document",
    "documentDesc": "testDoc.txt",
    "documentLink": "https://s3.us-east-1.amazonaws.com/mealmanageordered/householdApplicationVerifyDoc/QRWXp4oA-testDoc.txt"
  }
]

export const notesColumns = [
  {
    accessor: 'notes',
    Header: 'Notes',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'createdBy',
    Header: 'Added By',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'createdOn',
    Header: 'Added On',
    style: { textAlign: 'center' },
     Cell: ({ value }) => (
                    value && moment(value).isValid()
                        ? moment(value).format('YYYY-MM-DD') : '-'
           )
  },
]

export const notesData = [
  {
    "createdBy": "admin.pankaj@mealmanage.com",
    "createdOn": 1702121314000,
    "id": 9,
    "inputType": "note",
    "notes": "test note3"
  },
]

export const disSummaryColumns = [
  {
    accessor: 'school',
    Header: 'School',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'totalApprovedApplications',
    Header: 'Total Approved Applications',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'selectedApplications',
    Header: 'Selected Applications',
    style: { textAlign: 'center' }
  },
  {
    accessor: 'percentage',
    Header: 'Percentage',
    style: { textAlign: 'center' }
  },
]

export const disSummaryData = [
  {
    "school": "School 1",
    "totalApprovedApplications": 100,
    "selectedApplications": 3,
    "percentage": '3%',
  },
  {
    "school": "School 2",
    "totalApprovedApplications": 200,
    "selectedApplications": 6,
    "percentage": '3%',
  },
  {
    "school": "School 1",
    "totalApprovedApplications": 10,
    "selectedApplications": 1,
    "percentage": '3%',
  },
]





// WEBPACK FOOTER //
// ./src/components/District/Applications/applicationTestData.js